import { Product } from './product';
import { Seat } from './seat';

export class Ticket {
  private _seat: Seat | null;
  private _product: Product | null;
  private _reservationId: string;
  private _discountName: string | null = null;
  private _discountedAmount: number | null = null;

  constructor(seat: Seat = null, product: Product = null, reservationId: string = null) {
    this._seat = seat;
    this._product = product;
    this._reservationId = reservationId;
  }

  setDiscount(name: string | null, amount: number | null): void {
    this._discountName = name;
    this._discountedAmount = amount;
  }

  get discountName(): string | null {
    return this._discountName;
  }

  get discountedAmount(): number | null {
    return this._discountedAmount;
  }

  assignSeat(seat: Seat): void {
    this._seat = seat;
  }

  unassignSeat(): void {
    this._seat = null;
  }

  assignProduct(product: Product): void {
    this._product = product;
  }

  setProductReservation(reservationId: string): void {
    this._reservationId = reservationId;
  }

  hasProductReservation(): boolean {
    return !!this._reservationId;
  }

  get reservationId(): string {
    return this._reservationId;
  }

  get seat(): Seat {
    return this._seat;
  }

  get product(): Product {
    return this._product;
  }
}
